import * as React from "react";
const GlobIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    className={className}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.833 8a4.833 4.833 0 1 1-9.666 0 4.833 4.833 0 0 1 9.666 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.167 8c0 3-1.339 4.833-2.167 4.833C7.172 12.833 5.833 11 5.833 8S7.172 3.167 8 3.167C8.828 3.167 10.167 5 10.167 8ZM3.333 8h9.334"
    />
  </svg>
);
export default GlobIcon;
